export var FIELD_ENUM;
(function(FIELD_ENUM2) {
  FIELD_ENUM2["NAME"] = "NAME";
  FIELD_ENUM2["IMAGE"] = "IMAGE";
  FIELD_ENUM2["DESC"] = "DESC";
})(FIELD_ENUM || (FIELD_ENUM = {}));
export const MapKeyName = {
  [FIELD_ENUM.NAME]: "productName",
  [FIELD_ENUM.DESC]: "description",
  [FIELD_ENUM.IMAGE]: "images"
};
